import React from 'react';
import { PropertyGroup } from './PropertyGroup';

/**
 * Paragraph type property component
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ParagraphTypeProperty = _ref => {
  let {
    field,
    updateField,
    selectedField
  } = _ref;
  if (field.type !== 'paragraph') {
    return null;
  }
  return /*#__PURE__*/_jsx(PropertyGroup, {
    label: "Paragraph Type",
    children: /*#__PURE__*/_jsxs("select", {
      value: field.paragraphType || 'p',
      onChange: e => updateField(selectedField, {
        paragraphType: e.target.value
      }),
      className: "property-input",
      children: [/*#__PURE__*/_jsx("option", {
        value: "p",
        children: "Paragraph (p)"
      }), /*#__PURE__*/_jsx("option", {
        value: "address",
        children: "Address"
      }), /*#__PURE__*/_jsx("option", {
        value: "blockquote",
        children: "Blockquote"
      }), /*#__PURE__*/_jsx("option", {
        value: "canvas",
        children: "Canvas"
      }), /*#__PURE__*/_jsx("option", {
        value: "output",
        children: "Output"
      })]
    })
  });
};